import {
    faQuoteLeft,
    faQuoteRight,
} from '@awesome.me/kit-eee5f32034/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type QuoteProps = {
    children: React.ReactNode;
    author: string;
    className?: string;
};

export default function Quote({
    children,
    author,
    className = null,
}: QuoteProps) {
    return (
        <div className={`prose relative ${className}`}>
            <div>
                <FontAwesomeIcon
                    icon={faQuoteLeft}
                    fontSize={44}
                    className='opacity-30 dark:opacity-100 -ml-3 lg:-ml-10 dark:text-neutral-600'
                />
            </div>
            <blockquote className='*:before:hidden *:after:hidden pl-0 border-0 text-base md:text-lg lg:text-xl'>
                {children}
            </blockquote>
            <div className='flex justify-end'>
                <FontAwesomeIcon
                    icon={faQuoteRight}
                    fontSize={44}
                    className='opacity-30 dark:opacity-100 dark:text-neutral-600'
                />
            </div>
            <figcaption>
                <strong className='!text-secondary text-xl lg:text-2xl'>
                    {author}
                </strong>
            </figcaption>
        </div>
    );
}
